import { getCowbellTranslations } from '../../../../i18n/translations';

import type { Region } from '../../../../i18n/i18n.language-config';

const { t } = getCowbellTranslations();

interface IGetCountOfCbDisplayedParams {
  isNkllAttestationMandatory?: boolean;
  isTriaExcludedAttestationMandatory?: boolean;
}

export const getCountOfCbDisplayed = (
  params: IGetCountOfCbDisplayedParams = {}
): number => {
  let count = 1;
  if (params?.isNkllAttestationMandatory) {
    count++;
  }
  if (params?.isTriaExcludedAttestationMandatory) {
    count++;
  }
  return count;
};

// Platform text configuration for No Known Loss Letter / No Claims Declaration
export const getNoKnownLossLetterText = (region: Region) => {
  if (region.isAU) {
    return {
      // Document names
      documentName: 'No Claims Declaration',
      documentNameShort: 'NCD',
      documentNameAbbreviation: 'NCD',

      // Button text
      downloadButtonText: 'Download blank NCD',
      downloadButtonName: 'No Claims Declaration',

      // Checkbox labels
      checkboxLabel: `${t('check')} to verify signature and date of NCD.`,

      // Tooltips
      providedTooltip: 'Certificate of No Claims Declaration received',
      requiredTooltip: 'Certificate of No Claims Declaration required',

      // Form labels
      dontHaveDocumentText: "Don't have the signed NCD?",
    };
  }

  // Default for US/UK
  return {
    documentName: 'No Known Loss Letter',
    documentNameShort: 'NKLL',
    documentNameAbbreviation: 'NKLL',
    downloadButtonText: 'Download blank NKLL',
    downloadButtonName: 'No Known Loss Letter',
    checkboxLabel: `${t('check')} to verify signature and date of NKLL.`,
    providedTooltip: 'Certificate of No Known Loss letter received',
    requiredTooltip: 'Certificate of No Known Loss required',
    dontHaveDocumentText: "Don't have the signed NKLL?",
  };
};
